export default "__VITE_ASSET__DV4JpxD4__"